/** Modal ids that host a Google GIS button. A late One Tap cancel() aborts that button's FedCM get(). */
export const GOOGLE_BUTTON_ACCOUNT_MODAL_IDS = ['accountAccess', 'ssr-account-access'] as const

const googleButtonAccountModalIds: ReadonlySet<string> = new Set(GOOGLE_BUTTON_ACCOUNT_MODAL_IDS)

export function isGoogleButtonAccountModalOpen(modalIds: ReadonlyArray<string>): boolean {
  return modalIds.some((id) => googleButtonAccountModalIds.has(id))
}

export function cancelGoogleOneTap() {
  window.google?.accounts?.id?.cancel()
}

let suppressGoogleOneTapCount = 0

export function beginSuppressGoogleOneTap() {
  suppressGoogleOneTapCount += 1
  cancelGoogleOneTap()
}

export function endSuppressGoogleOneTap() {
  suppressGoogleOneTapCount = Math.max(0, suppressGoogleOneTapCount - 1)
}

export function isGoogleOneTapSuppressed(): boolean {
  return suppressGoogleOneTapCount > 0
}
